import variance from "./variance";

export default function(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/deviation.js
// module id = 562
// module chunks = 0